import { useWeb3React } from '@web3-react/core'
import { TransactionSummary } from 'components/AccountDetails/TransactionSummary'
import { AutoColumn } from 'components/Column'
import { AutoRow } from 'components/Row'
import { useContext } from 'react'
import { AlertCircle, CheckCircle } from 'react-feather'
import { useTransaction } from 'state/transactions/hooks'
import styled, { ThemeContext } from 'styled-components/macro'
import { ThemedText } from 'theme'
import { ExternalLink } from 'theme'
import { ExplorerDataType, getExplorerLink } from 'utils/getExplorerLink'

const RowNoFlex = styled(AutoRow)`
  flex-wrap: nowrap;
`

export default function TransactionPopup({ hash }: { hash: string }) {
  const { chainId } = useWeb3React()

  const tx = useTransaction(hash)
  const theme = useContext(ThemeContext)

  if (!tx) return null
  const success = Boolean(tx.receipt && tx.receipt.status === 1)

  return (
    <RowNoFlex>
      <div style={{ paddingRight: 16 }}>
        {success ? <CheckCircle color={theme.green1} size={24} /> : <AlertCircle color={theme.red1} size={24} />}
      </div>
      <AutoColumn gap="8px">
        <ThemedText.Body
          maxHeight={'1.62vh'}
          fontWeight={300}
          fontFamily={'Roboto FlexVariable'}
          fontStyle={'normal'}
          fontSize={'16px'}
          lineHeight={'19px'}
          color={'#DEDEDE'}
        >
          <TransactionSummary info={tx.info} />
        </ThemedText.Body>
        {chainId && (
          <ExternalLink href={getExplorerLink(chainId, hash, ExplorerDataType.TRANSACTION)}>
            View on Explorer
          </ExternalLink>
        )}
      </AutoColumn>
    </RowNoFlex>
  )
}
